import React, { useState } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import UserSidebar from '../../components/sidebar/UserSidebar';
import AccountFunding from '../../components/AccountFunding/AccountFunding';
import PaymentHistory from '../../components/PaymentHistory/PaymentHistory';
import { useErrorLogging } from '../../hooks/useErrorLogging';
import './FundingPage.css';

const FundingPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'funding' | 'history'>('funding');
  const { logInfo } = useErrorLogging();

  const handleTabChange = (tab: 'funding' | 'history') => {
    logInfo('Switched funding page tab', { tab });
    setActiveTab(tab);
  };

  return (
    <DashboardLayout sidebar={<UserSidebar />}>
      <div className="funding-page">
        <div className="page-header">
          <h1>Fund Your Account</h1>
          <p>Manage your wallet and view transaction history</p>
        </div>

        <div className="funding-tabs">
          <button
            className={`tab-button ${activeTab === 'funding' ? 'active' : ''}`}
            onClick={() => handleTabChange('funding')}
          >
            Add Funds
          </button>
          <button
            className={`tab-button ${activeTab === 'history' ? 'active' : ''}`}
            onClick={() => handleTabChange('history')}
          >
            Transaction History
          </button>
        </div>

        <div className="funding-content">
          {activeTab === 'funding' && <AccountFunding />}
          {activeTab === 'history' && <PaymentHistory />}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default FundingPage;
